import React from 'react';
import FollowersList from './FollowersList';
import './index.scss'
const FollowerPage = ({ userId }) => {
 
  const containerStyle = {
    backgroundColor: "#e5e5e5",
    minHeight: "100vh",
    paddingTop: "100px",
    overflow: "hidden", 
  };

  const rowStyle = {
    display: 'flex',
    margin: 'auto',
    paddingBottom: '100px',
    width: '100%', 
    alignItems: 'flex-start', 
    justifyContent: 'flex-start',
    overflow: 'hidden',
  };
  return (
    <div style={containerStyle}>
     <h3 style={{borderBottom: "1px solid #aaa", margin: "0 30px 40px", padding: "0", fontSize: "20px", fontWeight: "500"}}>Followers Page</h3>
      <div style={rowStyle} className='infiniteScrollConatinerToChangeCustomCss'>
      <FollowersList userId={userId}/>
      </div>
    </div>
  );
}

export default FollowerPage;
